/**
 * Helpers for collaborative stem pin thresholds.
 * Stored value is location stems only (Stem 2, 3, 4, …). Base stem "1 person" is UI-only, not stored.
 * Fixed modes: every 2/3/4/5 additional users per location stem.
 */

export type StemThresholdMode = 'every2' | 'every3' | 'every4' | 'every5' | 'custom';

/** Detect mode and location-stem count. Accepts location-only array [2, 4, 6] or legacy [1, 2, 4, 6]. */
export function detectStemThresholdMode(arr: number[]): { mode: StemThresholdMode; count: number } {
  if (!Array.isArray(arr) || arr.length === 0) return { mode: 'every2', count: 3 };
  const first = arr[0];
  const rest = first === 1 ? arr.slice(1) : arr;
  if (rest.length === 0) return { mode: 'every2', count: 0 };
  const step = rest[0];
  if (![2, 3, 4, 5].includes(step)) return { mode: 'custom', count: rest.length };
  for (let i = 1; i < rest.length; i++) {
    if (rest[i] !== step * (i + 1)) return { mode: 'custom', count: rest.length };
  }
  return { mode: `every${step}` as StemThresholdMode, count: rest.length };
}

/** Build location-stem thresholds only: [step, 2*step, 3*step, …], no leading 1. */
export function buildFixedStemThresholds(mode: StemThresholdMode, count: number): number[] {
  if (mode === 'custom' || count < 1) return [];
  const step = mode === 'every2' ? 2 : mode === 'every3' ? 3 : mode === 'every4' ? 4 : mode === 'every5' ? 5 : 0;
  if (step === 0) return [];
  const arr: number[] = [];
  for (let i = 0; i < count; i++) arr.push(step * (i + 1));
  return arr;
}
